module.exports = __webpack_public_path__ + "static/kodiac-05@2x-7e920fca708972f333a72e65d2ac3d59.png";